import styled from 'styled-components';
import { defaultTransition } from 'styles/utils';
import { disabledWrapper, focus } from 'components/Form/shared';

export const RadioWrapper = styled.div`
  display: flex;
  font-size: ${props => props.theme.font.size[props.size]};
  line-height: ${props => props.theme.spacing.default};

  ${props => props.disabled && disabledWrapper}
`;

export const RadioInput = styled.input`
  appearance: none;
  position: relative;
  display: inline-block;
  vertical-align: top;
  min-width: ${props => props.theme.spacing.default};
  width: ${props => props.theme.spacing.default};
  max-width: ${props => props.theme.spacing.default};
  min-height: ${props => props.theme.spacing.default};
  height: ${props => props.theme.spacing.default};
  max-height: ${props => props.theme.spacing.default};
  margin: ${props =>
    `${props.theme.spacing.small} 0 ${props.theme.spacing.small} ${props.theme.spacing.small}`};
  padding: 0;
  cursor: pointer;
  outline: none;
  border: 1px solid ${props => props.theme.color.wfGrey400};
  border-radius: 50%;
  background-color: transparent;
  ${defaultTransition(['border-color', 'background-color', 'box-shadow'])}

  &:hover {
    ${props =>
      !props.disabled &&
      `
      border: 1px solid ${props.theme.color.primary};
    `}
  }

  &:checked {
    border: 4px solid ${props => props.theme.color.primary};
    background-color: ${props => props.theme.color.wfWhite};
  }

  &:disabled {
    ${disabledWrapper}
  }

  &:focus {
    ${focus}
  }
`;
